/* ff product page: "Hemen Al" (buy now) + tabs */
(() => {
  if (window.__ffProductInit) return;
  window.__ffProductInit = true;

  /* Buy now: reuse the real add-to-cart submit; product-form.js redirects to /checkout when `buyNow` is set. */
  document.addEventListener('click', (e) => {
    const btn = e.target.closest('[data-ff-buy-now]');
    if (!btn) return;
    const form = btn.closest('product-form');
    const submit = form && form.querySelector('.atc-button');
    if (!submit || submit.disabled || submit.getAttribute('aria-disabled') === 'true') return;
    form.buyNow = true;
    submit.click();
  });

  /* Vertical thumbnail column scrolls on its own: keep the clicked thumbnail in view. */
  document.addEventListener('click', (e) => {
    const item = e.target.closest('.ff-pdp .thumbnail-list__item');
    if (item) item.scrollIntoView({ block: 'nearest' });
  });

  /* Main-image arrows step through the thumbnail column, so media-gallery.js keeps handling the actual switch. */
  const caret = '<svg viewBox="0 0 10 6" fill="none" aria-hidden="true"><path fill-rule="evenodd" clip-rule="evenodd" d="M9.354.646a.5.5 0 00-.708 0L5 4.293 1.354.646a.5.5 0 00-.708.708l4 4a.5.5 0 00.708 0l4-4a.5.5 0 000-.708z" fill="currentColor"/></svg>';
  const addArrows = () => {
    document.querySelectorAll('.ff-pdp slider-component[id^="GalleryViewer"]').forEach((viewer) => {
      const gallery = viewer.closest('media-gallery');
      if (!gallery || viewer.querySelector('.ff-gallery-arrow') || !gallery.querySelector('.thumbnail-list__item')) return;
      [['prev', -1, 'Önceki görsel'], ['next', 1, 'Sonraki görsel']].forEach(([name, dir, label]) => {
        const btn = document.createElement('button');
        btn.type = 'button';
        btn.className = `ff-gallery-arrow ff-gallery-arrow--${name}`;
        btn.setAttribute('aria-label', label);
        btn.innerHTML = caret;
        btn.addEventListener('click', () => {
          const thumbs = [...gallery.querySelectorAll('.thumbnail-list__item .thumbnail')];
          const cur = thumbs.findIndex((t) => t.getAttribute('aria-current') === 'true');
          const target = thumbs[(Math.max(cur, 0) + dir + thumbs.length) % thumbs.length];
          if (target) target.click();
        });
        viewer.appendChild(btn);
      });
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', addArrows); else addArrows();
})();

/* <ff-tabs>: accessible tablist; panels are [role=tabpanel] children, tabs are [role=tab] buttons. */
if (!customElements.get('ff-tabs')) {
  customElements.define('ff-tabs', class FfTabs extends HTMLElement {
    connectedCallback() {
      this.tabs = [...this.querySelectorAll('[role="tab"]')];
      this.panels = [...this.querySelectorAll('[role="tabpanel"]')];
      this.tabs.forEach((tab, i) => {
        tab.addEventListener('click', () => this.select(i));
        tab.addEventListener('keydown', (e) => {
          const key = { ArrowRight: 1, ArrowLeft: -1 }[e.key];
          if (key) {
            e.preventDefault();
            this.select((i + key + this.tabs.length) % this.tabs.length, true);
          } else if (e.key === 'Home' || e.key === 'End') {
            e.preventDefault();
            this.select(e.key === 'Home' ? 0 : this.tabs.length - 1, true);
          }
        });
      });
    }

    select(index, focus = false) {
      this.tabs.forEach((tab, i) => {
        const on = i === index;
        tab.setAttribute('aria-selected', String(on));
        tab.tabIndex = on ? 0 : -1;
        this.panels[i].hidden = !on;
      });
      if (focus) this.tabs[index].focus();
    }
  });
}
